import React, { useEffect, useState } from "react";
import {
    Button,
} from "semantic-ui-react";
import { Select, Input, Col, Row, } from "antd";
import { ReactComponent as FlechaSelect } from "../../../../assets/flecha_select.svg";
import axios from 'axios'
const { Option, OptGroup } = Select;


const FiltroPalabra = ({ inputFilter, selectFilter, filterByMany, primeroDatostabla }: any) => {
    const [filtroAvanzado, setFiltroAvanzado] = React.useState(false);

    const [lines, setLines] = useState<any>([])
    const [categories, setCategories] = useState<any>([])
    const [wordToFilter, setWordToFilter] = useState<any>('')
    const [lineToFilter, setLineToFilter] = useState<any>('')
    const [categoryToFilter, setCategoryToFilter] = useState<any>('')
    const [statusToFilter, setStatusToFilter] = useState<any>('')

    const getLines = async () => {
        const response: any = await axios.get(`${process.env.REACT_APP_SERVER_JURA2}lines`)
        setLines(response.data.lines)
    }
console.log(lines)
    const handleInputChange = (e: any) => {
        console.log(e.target.value)
        setWordToFilter(e.target.value)
    }

    const handleLineChange = (value: any) => {
        setLineToFilter(value)

        let categoriesArray: any = []

        let filteredLine = lines.filter((line: any) => line.id === value)

        filteredLine[0].categories.forEach((category: any) => {
            categoriesArray.push(category)
        })

        setCategories(categoriesArray)
    }

    const handleCategoryChange = (value: any) => {
        setCategoryToFilter(value)
    }

    const handleStatusChange = (value: any) => {
        //selectFilter(value)
        setStatusToFilter(value)
    }

    const handleFilterSubmit = async () => {
        const filterUrl = `${process.env.REACT_APP_SERVER_JURA2}juries/filter/many-filters/?code_word=${wordToFilter}&lineId=${lineToFilter}&line_category=${categoryToFilter}&status=${statusToFilter}`

        filterByMany(filterUrl)
    }
    const handleReset = (e:any) =>{
        setLineToFilter('')
        setCategoryToFilter('')
        setStatusToFilter(null)
        setWordToFilter('')
        // handleFilterSubmit()
        primeroDatostabla();
    }

    useEffect(() => {
        getLines()
    }, [])

    return (
        <>
        <Row className="width-5" style={{ width: '350px' }}>
            <Col span={24}>
                <span>Filtrar por palabra</span>
            </Col>
            <Col span={23}>
                <Input type="text" /* onKeyUp={inputFilter} */ value={wordToFilter} onChange={(e) => handleInputChange(e)} />
            </Col>
        </Row>
        <Button
            style={{ marginTop: "auto" }}
            icon="filter"
            className="button-filtro-adminconvocatorias"
            onClick={() => setFiltroAvanzado(!filtroAvanzado)}
        />
        {filtroAvanzado ? (
            <div className="" style={{marginTop:'20px', marginBottom: "10px", width: '100%' }}>
                <Row className="width-100" gutter={[16, 16]} style={{ display: 'flex', justifyContent: 'center', marginBottom: "10px", width: '100%' }}>
                    <Col span={8}>
                        <Row className="width-100" style={{ marginBottom: "10px", width: '100%' }}>
                            <Col span={30}>
                                <span>Filtrar línea</span>
                            </Col>
                            <Col span={24}>
                                <Select
                                suffixIcon={<FlechaSelect />}
                                    style={{ width: "100%" }}
                                    placeholder="Seleccionar..."
                                    onChange={(e) => handleLineChange(e)}
                                    value={lineToFilter}
                                >
                                    {
                                        lines.map((line: any, index: number) => (
                                            <Option key={line.id} value={line.id} >{line.name}</Option>
                                        ))
                                    }
                                </Select>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={8}>
                        <Row className="width-100">
                            <Col span={30}>
                                <span>Filtrar Categoría</span>
                            </Col>
                            <Col span={24}>
                                <Select
                                suffixIcon={<FlechaSelect />}
                                    style={{ width: "100%" }}
                                    placeholder="Seleccionar..."
                                    onChange={(e) => handleCategoryChange(e)}
                                    value={categoryToFilter}
                                >
                                    {
                                        categories.map((category: any, index: number) => (
                                            <Option key={category.id} value={category.id} >{category.name}</Option>
                                        ))
                                    }
                                </Select>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={8}>
                        <Row className="width-100">
                            <Col span={30}>
                                <span>Filtrar Estado</span>
                            </Col>
                            <Col span={24}>
                                <Select suffixIcon={<FlechaSelect />} value={statusToFilter} onChange={(e) => handleStatusChange(e)} style={{ width: "100%" }} placeholder="Seleccionar...">
                                    <Option value="Postulado">Postulado</Option>
                                    <Option value="Aceptó">Aceptó</Option>
                                    <Option value="No aceptó">No aceptó</Option>
                                    <Option value="No responde">No responde</Option>                                    
                                </Select>
                            </Col>
                        </Row>
                    </Col>

                </Row>
                <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Col >
                        <Button className="button-azul-ghost" type="reset" onClick={(e)=>handleReset(e)} >
                            LIMPIAR FILTROS
                        </Button>
                        <Button className="button-azul-radius" onClick={handleFilterSubmit}>
                            BUSCAR
                        </Button>
                    </Col>
                </Row>  </div>

        ) : null}

    </>
    )
}

export default FiltroPalabra
